export default [
  {
    name: 'label.cs',
    label: {
      cs: 'Popisek [CS]',
      en: 'Label [CS]',
    },
    main: true,
    input: 'input',
    type: 'string',
    minLength: 2,
    maxLength: 32,
    required: true,
  },
  {
    name: 'label.en',
    label: {
      cs: 'Popisek [EN]',
      en: 'Label [EN]',
    },
    main: true,
    input: 'input',
    type: 'string',
    minLength: 2,
    maxLength: 32,
    required: true,
  },
  {
    name: 'color',
    label: {
      cs: 'Barva',
      en: 'Color',
    },
    input: 'select-menu',
    elements: [
      { value: 'blue', label: 'Blue' },
      { value: 'dark-blue', label: 'Dark blue' },
      { value: 'dark-green', label: 'Dark green' },
      { value: 'dark-red', label: 'Dark red' },
      { value: 'green', label: 'Green' },
      { value: 'light-blue', label: 'Light blue' },
      { value: 'light-green', label: 'Light green' },
      { value: 'orange', label: 'Orange' },
      { value: 'purple', label: 'Purple' },
      { value: 'red', label: 'Red' },
      { value: 'turquoise', label: 'Turquoise' },
      { value: 'yellow', label: 'Yellow' },
    ],
    type: 'string',
    minLength: 2,
    maxLength: 32,
    required: true,
  },
  {
    name: 'icon',
    label: {
      cs: 'Ikona',
      en: 'Icon',
    },
    input: 'input',
    note: 'List',
    link: 'https://fontawesome.com/search?o=r&m=free',
    type: 'string',
    minLength: 2,
    maxLength: 32,
    required: true,
  },
  {
    name: 'from.date',
    label: {
      cs: 'Od (datum)',
      en: 'From (date)',
    },
    input: 'input',
    placeholder: 'DD.MM.YYYY',
    type: 'date',
    required: true,
  },
  {
    name: 'from.time',
    label: {
      cs: 'Od (čas)',
      en: 'From (time)',
    },
    input: 'input',
    placeholder: 'HH:MM',
    note: 'Optional',
    type: 'time',
  },
  {
    name: 'to.date',
    label: {
      cs: 'Do (datum)',
      en: 'To (date)',
    },
    input: 'input',
    placeholder: 'DD.MM.YYYY',
    note: 'Optional',
    type: 'date',
  },
  {
    name: 'to.time',
    label: {
      cs: 'Do (čas)',
      en: 'To (time)',
    },
    input: 'input',
    placeholder: 'HH:MM',
    note: 'Optional',
    type: 'time',
  },
  {
    name: 'place',
    label: {
      cs: 'Místo',
      en: 'Place',
    },
    input: 'input',
    type: 'string',
    minLength: 2,
    maxLength: 32,
    required: true,
  },
  {
    name: 'link',
    label: {
      cs: 'Odkaz',
      en: 'Link',
    },
    input: 'input',
    note: 'Optional',
    type: 'string',
    minLength: 2,
    maxLength: 128,
  },
];
